import axios from "axios";
import { backUrlAgent } from "../utils/backURL";
const API_URL = backUrlAgent;

export const analyzeFlowStats = async (prompt, currentStats, columnsExample, idClient, idFlow) => {
  try {
    const response = await axios.post(`${API_URL}/stats/analyze`, {
      prompt,
      current_stats: currentStats,
      columns_example: columnsExample,
      id_client: idClient,
      id_flow: idFlow
    });

    if (response.status === 200) {
      return {
        success: true,
        data: response.data
      };
    } else {
      console.error("Error en la respuesta del servidor:", response);
      return {
        success: false,
        error: "Error al analizar las estadísticas"
      };
    }
  } catch (error) {
    console.error("Error al llamar al endpoint de análisis:", error);
    return {
      success: false,
      error: error.message || "Error al analizar las estadísticas"
    };
  }
};